

const Constants = {
   SetRecentCards: 'card_SetRecentCards',
   SetCardList: 'card__SetCardList',
   AddCardToUnapprovedList: 'card__AddCardToUnapprovedList',
   SetUnapproved: 'card_SetUnapproved',
   SetConjectureGame: 'card_SetConjectureGame',
   SetToReview: 'card_SetToReview'
};

exports.CardReducer = (state={},action) =>{
   switch(action.type){
      case Constants.SetRecentCards:
         return {...state, recentCards: action.recentCards};
      case Constants.SetCardList:
         return {...state, cardList: action.cardList};
      case Constants.AddCardToUnapprovedList:{
         let unapprovedList = state.unapprovedList.slice();
         unapprovedList.unshift(action.card);
         return {...state, unapprovedList}
      }
      case Constants.SetUnapproved:
         return {...state, unapprovedList: action.unapprovedList};
      case Constants.SetConjectureGame:
         return {...state, conjectureGameList: action.conjectureGameList};
      case Constants.SetToReview:
         return {...state, toReview: action.toReview};
      default:
         return state;
   }
};

const FunctionList = {};

FunctionList.setRecentCards = (recentCards) => {
   return{
      type: Constants.SetRecentCards,
      recentCards
   }
};

FunctionList.setCardList = (cardList) => {
   return{
      type: Constants.SetCardList,
      cardList
   }
};

FunctionList.addCardToUnapprovedList = (card) => {
   return{
      type: Constants.AddCardToUnapprovedList,
      card
   }
};

FunctionList.setUnapproved = (unapprovedList) => {
   return{
      type: Constants.SetUnapproved,
      unapprovedList
   }
};

FunctionList.setConjectureGame = (conjectureGameList) => {
   return{
      type: Constants.SetConjectureGame,
      conjectureGameList
   }
};

FunctionList.setToReview = (toReview) => {
   return{
      type: Constants.SetToReview,
      toReview
   }
};

exports.FunctionList = FunctionList;
